import store from '../store/store'

export function checkOrganisationPermissions(action, module, scope, users = null) {
    let permissions = store.state.organisation.user_permissions || []
    console.log("checkOrganisationPermissions - checking:", `${action} on ${module} (${scope})`, "permissions array:", permissions)
    let permission_list = []

    if (scope == 'any' || scope == 'all') {
        permission_list.push(`${action}__all__${module}`)
        permission_list.push(`${action}__assigned__${module}`)
        permission_list.push(`${action}__own__${module}`)

    } else {
        if (Array.isArray(scope)) {
            scope.forEach(val => {
                permission_list.push(`${action}__${val}__${module}`)
            })

        } else {
            permission_list.push(`${action}__${scope}__${module}`)
        }
    }
    
    // permission check
    for (let i = 0; i < permission_list.length; i++) {
        if (permissions.includes(permission_list[i])) {
            // if above permission exists then we are checking that users array is there and current permission_list includes own or assigned 
            // if yes then we are checking current logged in user id is there in users array, not then simply returning false.
            if (
                users && (permission_list[i].includes('own') || permission_list[i].includes('assigned')) &&
                (store.state.organisation.organisation_user && !users.includes(store.state.organisation.organisation_user.id))
            ) {
                return false
            }
            return true
        }
    }

    return false
}